module.exports = __webpack_public_path__ + "media/application/images/bonington_how-it-works-ab4f2673b46a6ec2fad7a0cb283a1394.png";